import httpManager from "@/app/shared/utils/httpManager";
/**
 * Eliminar una base.
 *
 * @param {number} baseId Identificador de la base.
 */
export async function deleteBase(baseId) {
  await httpManager.delete(`/entities/portfolios/bases/${baseId}/`);
}
